import { useState, useEffect, useCallback } from "react";

import { Paper, Box } from "@mui/material";
import MediaQuery from "react-responsive";

import { api } from "../../services/axios";

const Header = ({ setPage }) => {
  const [image, setImage] = useState(null);
  const [link, setLink] = useState(null);

  const handleRedirectTo = useCallback(
    ({ path, external = false }) => {
      if (external) {
        window.open(path, "_blank");
        return;
      }

      setPage(path);
    },
    [setPage],
  );

  const handleRedirectBanner = useCallback(
    (bannerLink) => {
      if (!bannerLink) return;

      const isFullUrl = /^https?:\/\//.test(bannerLink);

      const internalPaths = {
        contaPerfil: 4,
      };

      const isInternalPath = Object?.keys?.(internalPaths)?.includes?.(bannerLink);

      if (!isFullUrl && !isInternalPath) return;

      let path = bannerLink;

      if (isInternalPath) {
        path = internalPaths[bannerLink];
      }

      handleRedirectTo({ path, external: isFullUrl });
    },
    [handleRedirectTo],
  );

  const handleGetBanner = useCallback(async () => {
    try {
      const { data: bannerResponse } = await api.post("portalCliente/exibe_banner", {
        jsessionid: localStorage.getItem("token"),
      });

      setImage(bannerResponse?.data);
      setLink(bannerResponse?.link);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    if (!image) {
      handleGetBanner();
    }
  }, [handleGetBanner, image]);

  if (!image) {
    return null; // Or a loading placeholder
  }

  return (
    <MediaQuery orientation="landscape">
      <Paper
        sx={{
          position: "relative",
          backgroundColor: "grey.800",
          color: "#fff",
          mb: 4,
          cursor: link ? "pointer" : "default",
          overflow: "hidden",
        }}
        onClick={() => handleRedirectBanner(link)}
      >
        <Box
          component="img"
          src={`data:image/png;base64,${image}`}
          alt="Banner"
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            objectFit: "cover",
            maxHeight: "300px",
          }}
        />
      </Paper>
    </MediaQuery>
  );
};

export default Header;
